import axios from "../axios/axios";
import { errorDispatcher } from "../helpers";
export const apiGetItemNote = (token, detail_id, detail_type, callback) => (dispatch) => {
  axios
    .get("notes", {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        detail_id,
        detail_type,
      },
    })
    .then((response) => {
      callback(response?.data?.notes);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
export const apiGetHistory = (token, detail_id, detail_type, callback) => (dispatch) => {
  axios
    .get("reports/history", {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        detail_id,
        detail_type,
      },
    })
    .then((response) => {
      callback(response?.data?.actions);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiCreateNote = (token, detail_id, detail_type, text, callback) => (dispatch) => {
  axios
    .post("notes", { detail_id, detail_type, text }, { headers: { Authorization: `Bearer ${token}` } })
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};

export const apiDeleteNote = (token, noteId, callback) => (dispatch) => {
  axios
    .delete(`notes/${noteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, false);
    });
};
